import { Component, ViewChild, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { ToastContainerComponent } from '../../shared/components/toast/toast-container.component';
import { GlobalSearchModalComponent } from '../../shared/components/search-modal/global-search-modal.component';
import { GuestWelcomeModalComponent } from '../../shared/components/guest-modal/guest-welcome-modal.component';
import { CreateTicketModalComponent } from '../../features/tickets/components/create-ticket-modal/create-ticket-modal.component';
import { WebSocketService } from '../../core/services/web-socket.service';
import { LayoutService } from '../../core/services/layout.service';
import { TicketService } from '../../core/services/ticket.service';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    HeaderComponent,
    SidebarComponent,
    ToastContainerComponent,
    GlobalSearchModalComponent,
    GuestWelcomeModalComponent,
    CreateTicketModalComponent,
  ],
  template: `
    <div class="h-screen w-screen overflow-hidden bg-slate-50 text-slate-900 dark:bg-slate-950 dark:text-slate-100 flex flex-col font-sans antialiased selection:bg-blue-600 selection:text-white transition-colors duration-200">
      
      <!-- Fixed Top Navigation Header -->
      <app-header
        class="shrink-0 z-30"
        (toggleSidebar)="layoutService.toggleSidebar()"
        (openSearch)="searchModal.openModal()" />

      <div class="flex-1 flex overflow-hidden min-h-0">
        <!-- Fixed Sidebar Navigation -->
        <app-sidebar #sidebar class="shrink-0 h-full overflow-hidden" />

        <!-- Main Content Viewport (Scrolls Alone) -->
        <main class="flex-1 overflow-y-auto min-h-0 bg-slate-50 dark:bg-slate-950 p-4 md:p-6 space-y-6 transition-colors duration-200">
          <router-outlet></router-outlet>
        </main>
      </div>

      <!-- Toast Container -->
      <app-toast-container />

      <!-- Global Search Modal (Ctrl + K) -->
      <app-global-search-modal #searchModal />

      <!-- Guest Welcome Popup Modal -->
      <app-guest-welcome-modal #guestModal />

      <!-- Create Ticket Modal (Single global instance supporting standard & drafted tickets) -->
      <app-create-ticket-modal
        [isOpen]="ticketService.isCreateModalOpen()"
        [initialData]="ticketService.createModalInitialData()"
        (close)="ticketService.closeCreateModal()" />

    </div>
  `,
})
export class AppLayoutComponent implements OnInit {
  private readonly webSocketService = inject(WebSocketService);
  readonly layoutService = inject(LayoutService);
  readonly ticketService = inject(TicketService);

  @ViewChild('searchModal') searchModal!: GlobalSearchModalComponent;

  ngOnInit(): void {
    // Automatically initialize WebSocket connection for every open tab/page
    this.webSocketService.init();
  }
}
